export default {
  "characteristics": {
    "title": "Características dos Cafés",
    "flavor": "Sabor",
    "flavor_description": "Frutas amarelas, caramelo, chocolate",
    "aroma": "Aroma",
    "aroma_description": "Frutas amarelas, chocolate",
    "body": "Corpo",
    "body_description": "Encorpado com textura de sedosa a cremosa",
    "acidity": "Acidez",
    "acidity_description": "Cítrica, brilhante e intensa",
    "finish": "Finalização",
    "finish_description": "De duração média e doce"
  }
}
